import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {ACCESSIBLE_NAME_SEPARATOR} from '../constants/ACCESSIBLE_NAME_SEPARATOR';

interface MatrixCellCoordinate {
  label: string;
  value: string | number | Nullish;
}

interface MatrixCellAccessibleName {
  /** What activating the cell does — "Add", "Edit variant". Announced first. */
  action: string;
  /** Where the cell sits in the matrix, announced as "label: value". Nil values are skipped. */
  coordinates: MatrixCellCoordinate[];
  /** The cell's state badges — "Active", "Configured". Nil entries are skipped. */
  statuses: Array<string | Nullish>;
}

/**
 * Joins the parts of a matrix cell's accessible name in a fixed order: what the cell does, where
 * it is, and what state it is in. The parts are named rather than positional so a caller cannot
 * silently swap a coordinate for a status.
 */
export function buildMatrixCellAccessibleName(name: MatrixCellAccessibleName) {
  const coordinates = name.coordinates
    .filter((coordinate) => isNotNil(coordinate.value))
    .map((coordinate) => `${coordinate.label}: ${coordinate.value}`);

  return [name.action, ...coordinates, ...name.statuses.filter(isNotNil)].join(
    ACCESSIBLE_NAME_SEPARATOR
  );
}
